import styles from './DrawerContent.module.css';

const DrawerContent = ({ children }) => {
  const noContent = () => (
    <div className={styles.noContent}>
      <span>Ничего не выбрано</span>
    </div>
  );

  return <div className={styles.container}>{children || noContent()}</div>;
};

export default DrawerContent;
